import { defaultHeaders } from '@/config/defaultHeaders.ts'
import baseApiService from '@/core/services/baseApiService.ts'
import {
  onFulfilledRequestInterceptor,
  onFulfilledResponseInterceptor,
  onRejectedRequestInterceptor,
  onRejectedResponseInterceptor
} from '@/core/services/interceptors.ts'
import axios, { AxiosResponse } from 'axios'
import { appConfig } from '@/config/app.ts'
import { validateSchema } from '@/core/utils/safeSchemaValidations.ts'
import { baseResponseSchema } from '@/core/types/BaseResponse.ts'

const axiosInstance = axios.create({
  baseURL: `${appConfig.apiUrl}/api/${appConfig.apiVersion}`,
  headers: defaultHeaders
})

axiosInstance.interceptors.request.use(
  onFulfilledRequestInterceptor,
  onRejectedRequestInterceptor
)

axiosInstance.interceptors.response.use(
  onFulfilledResponseInterceptor,
  (error) => onRejectedResponseInterceptor(error, axiosInstance)
)

const gestionApiService = baseApiService(
  axiosInstance,
  (response: AxiosResponse) => {
    validateSchema(baseResponseSchema, response?.data)
    return response?.data?.data
  }
)

export default gestionApiService
